import React, { useCallback, useRef, useState } from 'react'

import PropTypes from 'prop-types'

import toLower from 'lodash/toLower'

import { useDialog } from '@galo-monitor/dialog'
import I18n, { useT } from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'
import ModelForm from '@galo-monitor/web-containers/forms/root/ModelForm'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'

const ModelModal = (props) => {
  const {
    id,
    open,
    handleClose,
    model,
    onSuccess
  } = props

  const [loading, setLoading] = useState(false)

  const { createDialog } = useDialog()
  const t = useT()

  const formRef = useRef(null)

  const handleConfirm = useCallback(
    () => {
      formRef.current.submit()
    },
    []
  )

  const handleSuccess = useCallback(
    () => {
      handleClose()
      onSuccess()
    },
    [handleClose, onSuccess]
  )

  const onError = useCallback(
    response => {
      setLoading(false)
      createDialog({
        id: 'error-model-modal',
        Component: ErrorModal,
        props: {
          title: `${ t('could not {action} the {this}', {
            howMany: 1,
            gender: 'male',
            action: toLower(t(id ? 'update' : 'register')),
            this: toLower(t('model', { howMany: 1 }))
          })  }.`,
          message: t(response?.data?.message ?? response?.data?.errors?.[0]?.message)
        }
      })
    },
    [createDialog, id, t]
  )

  return (
    <Modal
      id={ id }
      open={ open }
      loading={ loading }
      title={ t('register of {this}', { this: t('model', { howMany: 1 }) }) }
      maxWidth="xs"
      fullWidth
      FooterComponent={ () => (
        <>
          <Button
            id="save"
            onClick={ handleConfirm }
          >
            <I18n>save</I18n>
          </Button>
        </>
      ) }
    >
      <ModelForm
        ref={ formRef }
        model={ model }
        onSuccess={ handleSuccess }
        onError={ onError }
        loading={ loading }
        setLoading={ setLoading }
      />
    </Modal>
  )
}

ModelModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  model: PropTypes.object
}

ModelModal.defaultProps = {
  model: {}
}

export default ModelModal
